"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    height: "24",
    viewBox: "0 0 38.4 24",
    width: "38.4",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m20.92 2.12h10.96v10.96h-10.96z"
  }), /*#__PURE__*/_react["default"].createElement("g", {
    fill: "none"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "m1.6 19.2h2.48a4 4 0 0 1 .74-1.6h-3.22z"
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    cx: "8",
    cy: "20",
    r: "2.4"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m14.4 12v-10.4h-5.93l-3.77 6.79-.13.18-3 3v4.43h12.83zm-2.4-7.2h-1.91l-2.17 4.36a.81.81 0 0 1 -.72.44.94.94 0 0 1 -.36-.08.82.82 0 0 1 -.36-1.08l2.4-4.8a.82.82 0 0 1 .72-.44h2.4a.8.8 0 0 1 0 1.6z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m20 14v-1.2h-4v3.2h20.8v-3.2h-4v1.2z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m11.18 17.6a4 4 0 0 1 .74 1.6h14.56a4 4 0 0 1 .74-1.6h-16z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m34.32 19.2h2.48v-1.6h-3.22a4 4 0 0 1 .74 1.6z"
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    cx: "30.4",
    cy: "20",
    r: "2.4"
  })), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m12 3.2h-2.4a.82.82 0 0 0 -.72.44l-2.4 4.8a.82.82 0 0 0 .36 1.08.94.94 0 0 0 .36.08.81.81 0 0 0 .72-.44l2.17-4.36h1.91a.8.8 0 0 0 0-1.6z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m37.6 11.2h-4.8v1.6h4v3.2h-20.8v-3.2h4v-1.6h-4v-10.4a.8.8 0 0 0 -.8-.8h-7.2a.81.81 0 0 0 -.7.41l-3.95 7.1-3.12 3.12a.81.81 0 0 0 -.23.57v8.8a.8.8 0 0 0 .8.8h3.28a4 4 0 0 0 7.84 0h14.56a4 4 0 0 0 7.84 0h3.28a.8.8 0 0 0 .8-.8v-8a.8.8 0 0 0 -.8-.8zm-33.52 8h-2.48v-1.6h3.22a4 4 0 0 0 -.74 1.6zm3.92 3.2a2.4 2.4 0 1 1 2.4-2.4 2.41 2.41 0 0 1 -2.4 2.4zm-6.4-6.4v-4.47l3-3 .13-.18 3.74-6.75h5.93v14.4zm24.88 3.2h-14.56a4 4 0 0 0 -.74-1.6h16a4 4 0 0 0 -.7 1.6zm3.92 3.2a2.4 2.4 0 1 1 2.4-2.4 2.41 2.41 0 0 1 -2.4 2.4zm6.4-3.2h-2.48a4 4 0 0 0 -.74-1.6h3.22z"
  }));
};

exports["default"] = _default;